import { useState } from "react";
import { Link } from "react-router";

import { AuthShell } from "../auth/AuthShell.tsx";
import { PATHS } from "../routes/routes.constants.ts";
import { RoleSignIn } from "./RoleSignIn.tsx";
import { ROLES, type RoleKey } from "./roles.ts";
import "./login.css";

export function LoginPage() {
  const [openRole, setOpenRole] = useState<RoleKey | null>("collector");

  return (
    <AuthShell>
      <h2 className="auth__heading">Welcome back</h2>
      <p className="auth__subheading">Choose your account and sign in.</p>

      <div className="login__roles">
        {ROLES.map((role) => (
          <RoleSignIn
            key={role.key}
            role={role}
            open={openRole === role.key}
            onToggle={() =>
              setOpenRole((current) => (current === role.key ? null : role.key))
            }
          />
        ))}
      </div>

      <p className="login__apply">
        Don&rsquo;t have an account?{" "}
        <Link className="login__apply-link" to={PATHS.apply}>
          Apply for access
        </Link>
      </p>
    </AuthShell>
  );
}
